import { render, staticRenderFns } from "./SidebarMediaDialog.vue?vue&type=template&id=98c13dc2&scoped=true"
import script from "./SidebarMediaDialog.vue?vue&type=script&lang=js"
export * from "./SidebarMediaDialog.vue?vue&type=script&lang=js"
import style0 from "./SidebarMediaDialog.vue?vue&type=style&index=0&id=98c13dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c13dc2",
  null
  
)

export default component.exports